import { CHANGE_SELECTED_ITEM, CLEAR_SELECTED_ITEM, DELETE_ITEM_SUCCESS, PUT_ITEM_SUCCESS, SET_DESCRIPTION_SUGGESTIONS, SET_ISLOADING, SET_ISLOADING_DESCRIPTION_SUGGESTIONS, SET_ITEMS, SET_SELECTED_START_DATE, SET_SUMMARY_ITEMS } from "../actions/timesheet.actions";
import { IActionBase } from "../models/IActionBase";
import { ITimesheetState } from "../models/ITimesheetState";

export const timesheetInitialState: ITimesheetState = {
    items: [],
    summaryItems: [],
    isLoading: false,
    selectedItem: null,
    descriptionSuggestions: [],
    isLoadingDescriptionSuggestions: false,
    selectedStartDate: new Date(),
    isPutItemSuccess: false
};

function timesheetReducer(state: ITimesheetState = timesheetInitialState, action: IActionBase): ITimesheetState {
    switch (action.type) {
        case SET_ITEMS: {
            return {
                ...state,
                items: action.items,
                isLoading: false
            }
        }
        case SET_SUMMARY_ITEMS: {
            return {
                ...state,
                summaryItems: action.summaryItems,
                isLoading: false,
                isPutItemSuccess: false
            }
        }
        case SET_ISLOADING: {
            return {
                ...state,
                isLoading: action.isLoading
            }
        }
        case CHANGE_SELECTED_ITEM: {
            return {
                ...state,
                selectedItem: action.item
            }
        }
        case CLEAR_SELECTED_ITEM: {
            return {
                ...state,
                selectedItem: null
            }
        }   
        case DELETE_ITEM_SUCCESS: {
            let items = state.items.filter(e => e.id !== action.item.id);

            return {
                ...state,
                items: items
            }
        }
        case PUT_ITEM_SUCCESS: {
            let items = state.items;

            let index = items.findIndex(e => e.id === action.item.id);

            if (index >= 0) {
                // Update.
                items[index] = action.item;
            }
            else {
                // Insert.
                items.push(action.item);
            }

            // Sort by Date descending to have the latest at the top.
            items.sort((a, b) => a.date < b.date ? 1 : -1);

            let descriptionSuggestions = state.descriptionSuggestions;

            // Update the list of descriptions.
            if (descriptionSuggestions.indexOf(action.item.description) === -1) {
                // Description not found in the list so add it as the first item.
                descriptionSuggestions.splice(0, 0, action.item.description);
            }

            return {
                ...state,
                items: items,
                descriptionSuggestions: descriptionSuggestions,
                isPutItemSuccess: true
            }
        }
        case SET_ISLOADING_DESCRIPTION_SUGGESTIONS: {
            return {
                ...state,
                isLoadingDescriptionSuggestions: action.isLoadingDescriptionSuggestions
            }
        }
        case SET_DESCRIPTION_SUGGESTIONS: {
            return {
                ...state,
                descriptionSuggestions: action.descriptionSuggestions,
                isLoadingDescriptionSuggestions: false
            }
        }
        case SET_SELECTED_START_DATE: {
            return {
                ...state,
                selectedStartDate: action.selectedStartDate
            }
        }
        default:
            // Redux will call our reducer with an undefined state for the first time: https://redux.js.org/basics/reducers#handling-actions
            return state;
    }
}

export default timesheetReducer;
